module.exports = "<ol class=\"breadcrumb\">\n  <li class=\"home\"><a [routerLink]=\"['/']\">Home</a></li>\n  <ng-content></ng-content>\n</ol>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/bread-crumb/bread-crumb.component.html
// module id = 1141
// module chunks = 0